// Use with getToken function returned by useInterstateToken hook
export const EXTERNAL_LEAD_COLOR_TOKEN = 'sem.color.primary.700';
export const INTERNAL_LEAD_COLOR_TOKEN = 'sem.color.primary.400';
